export default class Hold {
    static isFinished = (duration) => duration >= 10;
}
